import { render } from "./CancelButton.vue?vue&type=template&id=13040d4c"
import script from "./CancelButton.vue?vue&type=script&lang=js"
export * from "./CancelButton.vue?vue&type=script&lang=js"
script.render = render

export default script